export default {
    path: '/operate',
    name: 'operate',
    component: () => import('../../views/Layout/index'),
    meta: {
      title: '运营',
      // keepAlive: false
    },
    children: [
      {
        // 运营-分销管理
        path: 'distributionManage/distributionManageIndex',
        name: 'distributionManageIndex',
        component: () => import('../../views/Operate/DistributionManage/DistributionManageIndex'),
        meta: { title: '分销管理', keepAlive: false }
      },
      {
        // 运营-分账管理-订单
        path: 'splitBillManage/order',
        name: 'order',
        component: () => import('../../views/Operate/SplitBillManage/Order/OrderIndex'),
        meta: { title: '订单', keepAlive: false }
      },
      {
        // 运营-分账管理-订单-详情
        path: 'splitBillManage/orderDetail',
        name: 'orderDetail',
        component: () => import('../../views/Operate/SplitBillManage/Order/OrderDetail'),
        meta: { title: '订单详情', keepAlive: false }
      },
      {
        // 运营-分账管理-话费账单
        path: 'splitBillManage/phoneFee',
        name: 'phoneFee',
        component: () => import('../../views/Operate/SplitBillManage/PhoneFee/PhoneFeeIndex'),
        meta: { title: '话费账单', keepAlive: false }
      },
      {
        // 运营-分账管理-话费账单-详情
        path: 'splitBillManage/phoneFeeDetail',
        name: 'phoneFeeDetail',
        component: () => import('../../views/Operate/SplitBillManage/PhoneFee/PhoneFeeDetail'),
        meta: { title: '话费账单详情', keepAlive: false }
      },
      {
        // 运营-分账管理-激活奖励
        path: 'splitBillManage/activateBonus',
        name: 'activateBonus',
        component: () => import('../../views/Operate/SplitBillManage/ActivateBonus/ActivateBonusIndex'),
        meta: { title: '激活奖励', keepAlive: false }
      },
      {
        // 运营-分账管理-激活奖励
        path: 'splitBillManage/activateBonusDetail',
        name: 'activateBonusDetail',
        component: () => import('../../views/Operate/SplitBillManage/ActivateBonus/ActivateBonusDetail'),
        meta: { title: '激活奖励详情', keepAlive: false }
      },
    ]
  }